;(() => {
  class UpsellCards extends EventDispatcher {
    upsellSelects = document.querySelectorAll('.upsellSelector')
    upsellAddToCartButtons = document.querySelectorAll('.jsUpsellAddCta')
    upsellRemoveFromCartButtons = document.querySelectorAll('.jsUpsellRemoveCta')
    upsellAddedClass = 'pdp-upsell__item--added'
    parentClass = '.jsUpsellParent'

    constructor() {
      super()
      this.addEventListener()
    }

    addEventListener = () => {
      document.addEventListener('buyBoxHandler:variantChange', (event) => {
        this.onSelectChange(event)
        if (puffy.product.type != "bedding") {
          this.checkIFInCart()
        }
      })
      if (puffy.product.type != "bedding") {
        this.upsellAddToCartButtons.forEach((atcButton) => {
          atcButton.addEventListener('click', this.handleAddToCart)
        })
        this.upsellRemoveFromCartButtons.forEach((rfcButton) => {
          rfcButton.addEventListener('click', this.handleRemoveFromCart)
        })
        document.addEventListener('cart:change', () => {
          this.checkIFInCart()
        })
      }
    }

    toggleProgress = (node) => node.classList.toggle('in--progress')
    toggleSuccessClass = (node) => node.classList.toggle(this.upsellAddedClass)

    checkIFInCart = () => {
      fetch(`/cart.js`)
        .then((response) => response.json())
        .then((data) => {
          this.setUpsellCurrentStates(data.items)
        })
    }

    setUpsellCurrentStates = (cart) => {
      const upsellSelectors = document.querySelectorAll('.upsellSelector')
      upsellSelectors.forEach((upsellSelector) => {
        const upsellSelectorID = parseInt(upsellSelector.value)
        const parentNode = upsellSelector.closest(this.parentClass)

        cart.some(cartItem => {
          if (cartItem.id == upsellSelectorID) {
            parentNode.classList.add(this.upsellAddedClass);
            return true; 
          } else {
            parentNode.classList.remove(this.upsellAddedClass);
          }
          return false;
        });

        parentNode.classList.remove('in--progress')
      })
    }

    handleAddToCart = (event) => {

      const parentNode = event.target.closest(this.parentClass)
      console.log("🚀 ~ UpsellCards ~ parentNode:", parentNode)
      this.toggleProgress(parentNode)
      const currentSelectorID = parentNode.querySelector('.upsellSelector').value
      this.ajaxAddToCart(currentSelectorID).catch((err) => {
        console.error(
          'Error While Adding Upsell to Cart : Check File : upsell-cards.js',
          err
        )
      })
    }

    handleRemoveFromCart = (event) => {
      const parentNode = event.target.closest(this.parentClass)
      this.toggleProgress(parentNode)
      const currentSelectorID =
        parentNode.querySelector('.upsellSelector').value
      this.ajaxRemoveFromCart(currentSelectorID)
        .then(() => this.toggleSuccessClass(parentNode))
        .catch((err) => {
          console.error(
            'Error While Removing Upsell from Cart: Check File: upsell-cards.js',
            err
          )
        })
    }

    onSelectChange = (event) => {
      event.detail.split('/').forEach((handle) => {
        handle = handle.trim()
        if(handle == "Split King" && puffy.product.type == 'adj-base'){
          handle = "King";
        }
        if(handle == "King" && puffy.product.type == 'mattress'){
          handle = "Split King";
        }

        this.upsellSelects.forEach((upsellSelect) => {

          if (puffy.product.type == "bedding") {
            if(upsellSelect.getAttribute("id").includes("monarch")) {
              handle = "Twin XL";
            } else {
              handle = "Twin";
            }
          }

          const option = upsellSelect.querySelector(`option[label="${handle}"]`)
          if (option) {
            upsellSelect.value = option.value
            if (puffy.product.type != "bedding") {
              this.setSizeParam(handle)
            }
            this.setPricing(upsellSelect , option)
          }
        })
      })
    }

    setSizeParam = (handle) => {
      const upsellLinks = document.querySelectorAll('.jsUpsellParent .pdp-upsell__link');

      const sizeParam = handle.includes(' ') ? handle.replace(' ','-').toLowerCase(): handle.toLowerCase();

      upsellLinks.forEach(upsellLink => {
        const href = upsellLink.getAttribute('href');
        const url = new URL(href, window.location.origin);
        const params = new URLSearchParams(url.search);

        // Set or update the 'size' parameter
        params.set('size', sizeParam);

        // Update the href attribute with the new parameters
        url.search = params.toString();
        upsellLink.setAttribute('href', url.toString());
      })

    }

    setPricing = (upsellSelect , option) => {
      const oldPriceStr = option.getAttribute('data-old')
      const oldPrice = parseFloat(oldPriceStr.replace(/[$,]/g, ''));
      let price;
      const adJBase = upsellSelect.closest(this.parentClass).dataset.handle == "puffy-adjustable-base"
      if(adJBase){
        price = oldPrice - 300;
      }else{
        price = puffy.promoDiscount == 0 ? oldPrice - 1350 : oldPrice - 1500;
      }

      // if (puffy.isAffiliateCampaign && puffy.product.type == "bedding") {
      //   price = oldPrice - 1500;
      // }
      const formattedPrice = `$${price.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`.replace('.00','');;
      const formattedOldPrice = `$${oldPrice.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`.replace('.00','');
      upsellSelect.closest(this.parentClass).querySelector('.jsMattressUpsellPriceWithoutCode').textContent = formattedOldPrice
      upsellSelect.closest(this.parentClass).querySelector('.jsMattressUpsellPriceWithCode').textContent = formattedPrice
    }

  }

  

  document.addEventListener('product:init:upsells', () => new UpsellCards())
})()
